import { SurchargeInfo } from "@/models/pricing/price";
import { SurchargeState } from "./types";

export const getSurcharge = (state: SurchargeState): SurchargeInfo => {
  return {
    rate: state.rate,
    label: state.label,
    effective_date: state.effective_date
  };
};

export const getSurchargeIsActive = (state: SurchargeState): boolean => {
  return state.rate > 0;
};
